import React from "react";
import { Switch } from "react-router-dom";
import AppliedRoute from "./Routes/AppliedRoute.js";
import AuthenticatedRoute from "./Routes/AuthenticatedRoute";
import Case from "components/_Case/Case.js";
import Dashboard from "components/_Dashboard/Dashboard.js";
import Login from "components/_Login/Login.js";
import AllReports from "components/_AllReports/AllReports.js";
import MyReports from "components/_MyReports/MyReports.js";
import About from "components/_About/About.js";
import ResetPassword from "components/_ResetPassword/ResetPassword.js";
import DataExport from "components/_DataExport/DataExport.js";
import LegacyReportSearch from "components/_LegacyInspectionReports/LegacyReportSearch";
import LicenseAgreementPage from "components/_LicenseAgreement/LicenseAgreementPage.js";
import AdminApp from "./pages/admin-app/AdminApp.tsx";
import Distributors from "./pages/admin-app/distributor/DistributorsPage.tsx";
import TerritoryManager from "./pages/admin-app/territory-manager/TerritoryManagersPage.tsx";
import IndustrySpecialists from "./pages/admin-app/industry-specialist/IndustrySpecialistsPage.tsx";
import EndUsers from "./pages/admin-app/end-user/EndUsersPage.tsx";
import Vendors from "./pages/admin-app/vendor/VendorsPage.tsx";
import EditVendorPage from "./pages/admin-app/vendor/EditVendorPage.tsx";
import CreateVendorPage from "./pages/admin-app/vendor/CreateVendorPage.tsx";
import ViewVendorPage from "./pages/admin-app/vendor/ViewVendorPage.tsx";
import CreateIndustrySpecialistPage from "./pages/admin-app/industry-specialist/CreateIndustrySpecialistPage.tsx";
import EditIndustrySpecialistPage from "./pages/admin-app/industry-specialist/EditIndustrySpecialistPage.tsx";
import ViewIndustrySpecialistPage from "./pages/admin-app/industry-specialist/ViewIndustrySpecialistPage.tsx";
import EditTerritoryManagerPage from "./pages/admin-app/territory-manager/EditTerritoryManagerPage.tsx";
import CreateTerritoryManagersPage from "./pages/admin-app/territory-manager/CreateTerritoryManagerPage.tsx";
import CreateDistributorPage from "./pages/admin-app/distributor/CreateDistributorPage.tsx";
import EditDistributorPage from "./pages/admin-app/distributor/EditDistributorPage.tsx";
import ViewDistributorPage from "./pages/admin-app/distributor/ViewDistributorPage.tsx";
import CreateEndUserPage from "./pages/admin-app/end-user/CreateEndUserPage.tsx";
import EditEndUserPage from "./pages/admin-app/end-user/EditEndUserPage.tsx";
import CombinedReports from "components/_CombinedReports/CombinedReports.tsx";
import NAMorAdminRoute from "./Routes/NAMorAdminRoute.tsx";
import { usAdminAppRoutes } from "route-definitions.ts";
import ViewTerritoryManagerPage from "pages/admin-app/territory-manager/ViewTerritoryManagerPage.tsx";
import ViewEndUserPage from "pages/admin-app/end-user/ViewEndUserPage.tsx";

export default ({ childProps }) => (
  <Switch>
    <AppliedRoute exact path="/" component={Login} props={childProps} />
    <AppliedRoute path="/login" component={Login} props={childProps} />
    <AppliedRoute
      path="/reset-password"
      component={ResetPassword}
      props={childProps}
    />
    <AppliedRoute
      path="/license-agreement"
      component={LicenseAgreementPage}
      props={childProps}
    />
    <AuthenticatedRoute path="/case/:id" component={Case} props={childProps} />
    <AuthenticatedRoute path="/about" component={About} props={childProps} />
    <AuthenticatedRoute
      path="/dashboard"
      component={Dashboard}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/all-reports"
      component={AllReports}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/my-reports"
      component={MyReports}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/reports"
      component={CombinedReports}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/dataexport"
      component={DataExport}
      props={childProps}
    />
    <AuthenticatedRoute
      path="/legacyinspectionreports"
      component={LegacyReportSearch}
      props={childProps}
    />
    <NAMorAdminRoute
      exact
      path={usAdminAppRoutes.index}
      component={AdminApp}
      props={childProps}
    />
    <NAMorAdminRoute
      exact
      path={usAdminAppRoutes.vendors}
      component={Vendors}
      props={childProps}
    />
    <NAMorAdminRoute
      exact
      path={usAdminAppRoutes.createVendor}
      component={CreateVendorPage}
      props={childProps}
    />
    <NAMorAdminRoute
      exact
      path={usAdminAppRoutes.editVendor}
      component={EditVendorPage}
      props={childProps}
    />
    <NAMorAdminRoute
      exact
      path={usAdminAppRoutes.viewVendor}
      component={ViewVendorPage}
      props={childProps}
    />
    <NAMorAdminRoute
      exact
      path={usAdminAppRoutes.distributors}
      component={Distributors}
      props={childProps}
    />
    <NAMorAdminRoute
      exact
      path={usAdminAppRoutes.createDistributor}
      component={CreateDistributorPage}
      props={childProps}
    />
    <NAMorAdminRoute
      exact
      path={usAdminAppRoutes.editDistributor}
      component={EditDistributorPage}
      props={childProps}
    />
    <NAMorAdminRoute
      exact
      path={usAdminAppRoutes.viewDistributor}
      component={ViewDistributorPage}
      props={childProps}
    />
    <NAMorAdminRoute
      exact
      path={usAdminAppRoutes.territoryManagers}
      component={TerritoryManager}
      props={childProps}
    />
    <NAMorAdminRoute
      exact
      path={usAdminAppRoutes.createTerritoryManager}
      component={CreateTerritoryManagersPage}
      props={childProps}
    />
    <NAMorAdminRoute
      exact
      path={usAdminAppRoutes.editTerritoryManager}
      component={EditTerritoryManagerPage}
      props={childProps}
    />
    <NAMorAdminRoute
      exact
      path={usAdminAppRoutes.viewTerritoryManager}
      component={ViewTerritoryManagerPage}
      props={childProps}
    />
    <NAMorAdminRoute
      exact
      path={usAdminAppRoutes.industrySpecialists}
      component={IndustrySpecialists}
      props={childProps}
    />
    <NAMorAdminRoute
      exact
      path={usAdminAppRoutes.createIndustrySpecialist}
      component={CreateIndustrySpecialistPage}
      props={childProps}
    />
    <NAMorAdminRoute
      exact
      path={usAdminAppRoutes.editIndustrySpecialist}
      component={EditIndustrySpecialistPage}
      props={childProps}
    />
    <NAMorAdminRoute
      exact
      path={usAdminAppRoutes.viewIndustrySpecialist}
      component={ViewIndustrySpecialistPage}
      props={childProps}
    />
    <NAMorAdminRoute
      exact
      path={usAdminAppRoutes.endUsers}
      component={EndUsers}
      props={childProps}
    />
    <NAMorAdminRoute
      exact
      path={usAdminAppRoutes.createEndUser}
      component={CreateEndUserPage}
      props={childProps}
    />
    <NAMorAdminRoute
      exact
      path={usAdminAppRoutes.editEndUser}
      component={EditEndUserPage}
      props={childProps}
    />
    <NAMorAdminRoute
      exact
      path={usAdminAppRoutes.viewEndUser}
      component={ViewEndUserPage}
      props={childProps}
    />
  </Switch>
);
